/// <amd-module name="TFS/Admin/Views/ProjectGroups/redux/ProjectGroupsReducer" />
import produce from "immer";

import { GroupsNavType } from "TFS/Admin/Groups/Common/Constants";
import { IGroupsPageState } from "TFS/Admin/Groups/Common/Contracts";
import { GroupsViewActions, GroupsViewActionTypes } from "TFS/Admin/Groups/Common/Redux/Actions/GroupsViewActions";

export function projectGroupsReducer(state: IGroupsPageState, action: GroupsViewActions): IGroupsPageState {
    return produce(state || {}, draft => {
        switch (action.type) {
            case GroupsViewActionTypes.InitialLoadSucceeded: {
                const { isCollectionNavigationAllowed, scopeDescriptor } = action.payload;
                draft.isCollectionNavigationAllowed = isCollectionNavigationAllowed;
                draft.scopeDescriptor = scopeDescriptor;
                draft.selectedNavType = GroupsNavType.Default;
                break;
            }

            case GroupsViewActionTypes.SelectedGroupChanged: {
                draft.selectedGroup = action.payload;
                draft.selectedNavType = GroupsNavType.GroupDetails;
                draft.selectedUser = undefined;
                break;
            }

            case GroupsViewActionTypes.SelectedUserChangedSuccessful: {
                draft.selectedUser = action.payload;
                draft.selectedNavType = GroupsNavType.UserDetails;
                draft.selectedGroup = undefined;
                break;
            }

            case GroupsViewActionTypes.SelectedServicePrincipalChangedSuccessful: {
                draft.selectedUser = action.payload;
                draft.selectedNavType = GroupsNavType.ServicePrincipalDetails;
                draft.selectedGroup = undefined;
                break;
            }

            case GroupsViewActionTypes.SelectedMemberChangedSuccessful: {
                draft.selectedMember = action.payload;
                draft.selectedNavType = GroupsNavType.MemberDetails;
                draft.selectedGroup = undefined;
                break;
            }

            case GroupsViewActionTypes.SelectedGroupPermissionsUpdate: {
                const { descriptor, permissions } = action.payload;
                if (draft.selectedGroup && draft.selectedGroup.descriptor === descriptor) {
                    draft.selectedGroup.actionPermissions = permissions;
                }
                break;
            }

            case GroupsViewActionTypes.GroupEdited: {
                const graphGroup = action.payload;
                if (draft.selectedGroup) {
                    draft.selectedGroup.displayName = graphGroup.displayName;
                    draft.selectedGroup.principalName = graphGroup.principalName;
                    draft.selectedGroup.description = graphGroup.description;
                }
                break;
            }

            case GroupsViewActionTypes.SetFilterPlaceHolder: {
                const placeholder: string = action.payload;
                draft.filterPlaceHolder = placeholder;
                break;
            }

            case GroupsViewActionTypes.GroupAvatarUpdatedUrl: {
                draft.updatedAvatarUrl = action.payload;
                break;
            }

            case GroupsViewActionTypes.PermissionPage: {
                draft.permissionPage = action.payload;
                break;
            }

            default:
                return state;
        }
    });
}
